import { BoneIcon, BrainStressIcon, EssentialIcon, ImmuneVascularIcon, OpticIcon, SkinHairIcon } from '../../../../../public/assets/icons';


export const METRIC_CONFIG = {
  essential: {
    title: 'Essential Nutrients',
    icon: EssentialIcon,
  },
  optic: {
    title: 'Optic',
    icon: OpticIcon,
  },
  brain: {
    title: 'Brain & Stress',
    icon: BrainStressIcon,
  },
  skin: {
    title: 'Skin & Hair',
    icon: SkinHairIcon,
  },
  bone: {
    title: 'Bone',
    icon: BoneIcon,
  },
  immune: {
    title: 'Immune & Vascular',
    icon: ImmuneVascularIcon,
  },
};
